import { render, staticRenderFns } from "./BuildMapping.vue?vue&type=template&id=8676ae34&scoped=true&v-if=maps&"
import script from "./BuildMapping.vue?vue&type=script&lang=js&"
export * from "./BuildMapping.vue?vue&type=script&lang=js&"
import style0 from "./BuildMapping.vue?vue&type=style&index=0&id=8676ae34&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8676ae34",
  null
  
)

export default component.exports